/* eslint-disable no-magic-numbers */
import { isMobile } from 'Helpers/devices';

export const IMAGE_MAX_SIZE = 9961472;
export const QUALITY_IMAGE_60 = '60';

export const X = '1x';
export const XX = '2x';
export const XXX = '3x';

export const WEBP_EXT = 'webp';
export const PNG_EXT = 'png';
export const SVG_EXT = 'svg';
export const GIF_EXT = 'gif';
export const JPG_EXT = 'jpg';

export const WEBP_TYPE = [WEBP_EXT];
export const WEBP_PNG_TYPE = [WEBP_EXT, PNG_EXT];

export const WEBP_SVG_TYPE = [SVG_EXT, WEBP_EXT];
export const SVG_TYPE = [SVG_EXT];

export const MODE = {
    LIGHT: 'light',
    DARK: 'dark'
};

export const ASPECT_RATIO = 16 / 9;
export const DEFAULT_IMG_HEIGHT = isMobile ? '240' : '480';

export const MAIN_IMG_GALLERY_WIDTH_ADPV = isMobile ? '360' : '850';

export const INSPECTION_IMG_GALLERY_WIDTH_ADPV = isMobile ? '300' : '380';

export const INSPECTION_IMG_GALLERY_HEIGHT_ADPV = isMobile ? DEFAULT_IMG_HEIGHT : '245';

export const SEO_OG_IMAGE_WIDTH = '1280';

export const MEDIAVERSE_DOMAIN_IDENTIFIER = 'apollo';

export const IMAGE_SIZE_DEFAULT = isMobile ? '300x600' : '600x1200';

export const IMAGE_PARAMS_QUALITY_60 = `s=${IMAGE_SIZE_DEFAULT};q=${QUALITY_IMAGE_60}`;
